import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'wsb-grid-price-renderer',
  template: `
    <div [ngClass]="{ 'two-rows': secondRow }">
      <span class="first-row">{{ firstRow }}</span>
      <br />
      <span class="second-row">{{ secondRow }}</span>
    </div>
    <wsb-atlas-button *ngIf="buttonIcon !== null" class="mb-2" [variant]="'primary'" [icon]="buttonIcon" (click)="buttonClick($event)">{{
      'common_edit' | translate
    }}</wsb-atlas-button>
  `,
  standalone: false
})
export class AtlasGridPriceRendererComponent implements ICellRendererAngularComp {
  params;
  firstRow: string;
  secondRow: string;
  buttonIcon: string | null;

  agInit(params): void {
    this.params = params;
    this.firstRow = this.params.firstRow ? this.params.firstRow(params) : null;
    this.secondRow = this.params.secondRow ? this.params.secondRow(params) : null;
    this.buttonIcon = this.params.buttonIcon ? this.params.buttonIcon(params) : null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  buttonClick($event) {
    if (this.params.buttonClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        data: this.params.node.data
        // ...something
      };
      this.params.buttonClick(params);
    }
  }
}
